<script>
import axios from "axios";

import TeacherFormPreview from "@/components/notecatcher/teachers/TeacherFormPreview.vue";
import store from "../store/index.js";

const apiBase = API_APP_PATH + "/v1";

export default {
  data() {
    return {
      forms: {}
    };
  },
  created() {
    store.commit('currentPage', 'goalSetting')
    this.getResponses()
      .then(responses => {
        this.forms = this.getFormsFromResponses(responses);
      })
      .catch(e => {
        throw new Error(e);
      });
  },
  computed: {
    sortedForms() {
      return Object.values(this.forms).sort((f1, f2) => {
        let f1_open = new Date(f1.OpenWindow).getTime();
        let f2_open = new Date(f2.OpenWindow).getTime();
        if (f1_open < f2_open) return 1;
        if (f1_open > f2_open) return -1;
        return 0;
      });
    }
  },
  methods: {
    getFormsFromResponses(responses) {
      return responses.reduce((forms, response) => {
        if (!forms[response.FormID]) {
          forms[response.FormID] = {
            ...response,
            responses: []
          };
          forms[response.FormID].status = "Not Submitted";
        }
        if (response.Comment !== "" && response.Comment !== null) {
          if (response.ReferenceType !== "temp-form") {
            forms[response.FormID].responses.push(response.Comment);
            forms[response.FormID].status = "Submitted";
          } else {
            forms[response.FormID].status = "In Progress";
          }
        }
        return forms;
      }, {});
    },
    getResponses: async () => {
      return (
        await axios.get(
          `${apiBase}/data/school/goalSetting/teacher/${store.state.employeeId}`
        )
      ).data;
    }
  },
  components: {
    TeacherFormPreview
  }
};
</script>

<template>
  <div class="teacher-landing">
    <div class="welcome-note">
      <img src="@/assets/images/assignment.png" alt="assignment">
      <p>The Mid Year Reflection form can serve as a helpful tool for teachers and administrators in understanding how best to support Advance observations in the months ahead.</p>
    </div>
    <h3>The responses in these forms are shared back with your school leadership to help with mid-year conversations and future professional goal setting. As a reminder, responding to this is optional.</h3>
    <h3 style="text-decoration: underline; font-size: 2em;">All forms</h3>
    <div id="all-form-container">
      <TeacherFormPreview v-for="form in sortedForms" :key="form.FormId" :form="form" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.welcome-note {
    display: flex;
    align-items: center;
    font-family: Arial;
    color: #333333;
    padding: 1em;
    border: 2px solid #c4c4c4;
    border-radius: 8px;
    p {
      font-size: 1.25em;  
    }
    img {
      margin-right: 30px;
      width: 30px;
      height: 33px
    }
  }
.teacher-landing {
  font-family: Arial, Helvetica, sans-serif;
}
#all-form-container {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}
el-menu-item {
  width: 100px;
  height: 100px;
  border: 1px solid;
}
</style>